
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { CookieModalComponent } from './cookie-modal.component';
import { IgxSwitchModule } from "igniteui-angular";

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    IgxSwitchModule
  ],
  //declarations: [CookieModalComponent],
  providers: []
})
export class CookieModalModule { }
